export { useComponentProps } from './useComponentProps';
export { useComponentConfig } from './useComponentConfig';
export { useComponentMethods } from './useComponentMethods';
export { useComponentTranslations } from './useComponentTranslations';
